import { brandStats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="w-full py-14 md:py-18 bg-gradient-to-r from-primary-500 via-primary-600 to-accent-500">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 max-w-4xl mx-auto text-center">
          {brandStats.map((stat) => (
            <div key={stat.label} className="animate-fadeInUp">
              <div className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/75 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}